
const SESSION_KEY = 'userInfo';

export const saveSession = (userInfo: unknown): void => {
    try {
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(userInfo));
    } catch {
        /* storage indisponivel (modo privado/quota) — ignora */
    }
};

export const loadSession = <T = any>(): T | null => {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    try {
        return JSON.parse(raw) as T;
    } catch {
        return null;
    }
};

export const clearSession = (): void => {
    sessionStorage.removeItem(SESSION_KEY);
};
